var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"main-container"},[(_vm.isRoomDisplayMultiRoomVersionActive)?_c('MultiRoomDisplay',{attrs:{"if":"customer"}}):(_vm.loadRateDisplay)?_c('RoomRateDisplay',{attrs:{"if":"customer"}}):_c('RoomDisplay',{attrs:{"if":"customer"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }